export class ResourceWorkDataFakeDb {
  public static workData = [];
}
